import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { TeamState } from '../models/statements.models';
import { StatementsFacade } from '../services/statements.facade';

@Injectable({
  providedIn: 'root',
})
export class IsOnboardedToOwnerStatementsGuard {
  TRIAL_INTERSTITIAL_URL = '/operations/statements/onboarding';

  constructor(
    private router: Router,
    private statementsService: StatementsFacade
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.statementsService.showOwnerStatements$.pipe(
      take(1),
      switchMap((showOwnerStatements) => {
        if (!showOwnerStatements) return of(false); // redirect handled in can-see-statements.guard.ts

        return this.statementsService.teamState$.pipe(
          take(1),
          switchMap((teamState) => {
            if (!teamState.data && teamState.loading === false) {
              this.statementsService.getTeam();

              return this.statementsService.teamState$.pipe(
                filter((state) => state.loading === false),
                take(1),
                map((state) => this.checkTeamState(state))
              );
            } else {
              return of(this.checkTeamState(teamState));
            }
          })
        );
      }),
      take(1),
      catchError(() => {
        return of(this.router.createUrlTree([this.TRIAL_INTERSTITIAL_URL]));
      })
    );
  }

  private checkTeamState(teamState: TeamState): boolean | UrlTree {
    if (teamState.data?.status === 'finished') {
      return true;
    }

    return this.router.createUrlTree([this.TRIAL_INTERSTITIAL_URL]);
  }
}
